export function identifyFullStoryUser(uid, properties) {
  window.FS?.("setIdentity", { uid, properties });
}
